import { departmentService } from "../../../../Api/Services/DepartmentService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import {
  CreateDepartmentResponse,
  ICreateDepartmentPayload,
} from "../../../../Types/Common";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";

export const createDepartmentThunk = createServiceAsyncThunk<
  CreateDepartmentResponse,
  ICreateDepartmentPayload
>(
  ACTION_NAMES.CREATE_DEPARTMENT,
  (payload) => departmentService.createDepartment(payload),
  ERROR_MESSAGES.CREATE_DEPARTMENT_FAILURE
);

const createDepartmentSlice = createGenericSlice<
  CreateDepartmentResponse,
  ICreateDepartmentPayload
>(SLICE_NAMES.CREATE_DEPARTMENT, createDepartmentThunk);

export const {
  clearError: clearCreateDepartmentError,
  clearSuccessMessage: clearCreateDepartmentSuccess,
} = createDepartmentSlice.actions;

export default createDepartmentSlice.reducer;
